import { render } from "./ModalComponent.vue?vue&type=template&id=1ec69b00"
import script from "./ModalComponent.vue?vue&type=script&lang=js"
export * from "./ModalComponent.vue?vue&type=script&lang=js"

import "./ModalComponent.vue?vue&type=style&index=0&id=1ec69b00&lang=css"

import exportComponent from "/codebuild/output/src298404285/src/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ModalComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ec69b00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ec69b00', __exports__)) {
    console.log('reload')
    api.reload('1ec69b00', __exports__)
  }
  
  module.hot.accept("./ModalComponent.vue?vue&type=template&id=1ec69b00", () => {
    console.log('re-render')
    api.rerender('1ec69b00', render)
  })

}


export default __exports__